// RAINBOW GRID
// par defaut toutes des lunettes sont en noir et blanc, l'image du produit passe en gray scale de 0 à 1 (de noir et blanc à classique) 
// document.addEventListener("DOMContentLoaded", function () {
    //let previousCards = [];

    //window.toggleRandomCards = function () {
        //const cards = document.querySelectorAll(".mm-filter-rainbow-collection");

        // Remettre les anciennes en noir et blanc
       // previousCards.forEach(card => {
            // Ignorer les cartes dans .mm-predictive-search-container
            //if (card.closest(".mm-predictive-search-container")) return;

            //const img = card.querySelector("img");
           // if (img) img.style.filter = "grayscale(1)";
       // });

       // const newCards = [];
        //const validCards = Array.from(cards).filter(card => {
            // Ne garder que les cartes qui NE sont PAS dans .mm-predictive-search-container
          //  return !card.closest(".mm-predictive-search-container");
       // });

      //  const max = Math.min(8, validCards.length);
        //const indices = new Set();

        //while (indices.size < max) {
           // indices.add(Math.floor(Math.random() * validCards.length));
       // }

       // indices.forEach(index => {
        //    const card = validCards[index];
          //  const img = card.querySelector("img");
            //if (img) img.style.filter = "grayscale(0)";
            //newCards.push(card);
       // });

       // previousCards = newCards;
  //  }

    // Appliquer un premier effet au chargement
   // window.toggleRandomCards();
    // Puis lancer en boucle
   // setInterval(window.toggleRandomCards, 1200);
//});



/*********************************************************************************************
* Open / Close panel
	*
*/
const PANEL_FILTER = document.querySelector('.mm-product-panel-filter');

function mmOpenPanel(index) {
  const panel = document.querySelector(`.mm-panel[data-panel="${index}"]`);
  if (index == 1) {
    panel.innerHTML = `
    <div class="mm-flex mm-loading mm-align-center mm-justify-center mm-w-full mm-h-full">
    <span class="loader"></span>
    </div>
    `    
  }
  panel.classList.add('mm-visible');
  PANEL_FILTER.classList.add('mm-visible');
  document.querySelector('#ShopifyChat')?.classList.add('mm-opacity-0');
  document.querySelector('.mm-section-header').style.zIndex = "15";
}
function mmCloseThis(button_element) {
  const panel = button_element.closest('.mm-panel');
  panel.classList.remove('mm-visible');
  document.querySelector('#ShopifyChat')?.classList.remove('mm-opacity-0');
  setTimeout(() => {
    document.querySelector('.mm-section-header').style.zIndex = "16";
  }, "600");
}
function mmCloseAllPanels() {
  const panels = document.querySelectorAll('.mm-panel');
  panels.forEach(function(panel) {
    panel.classList.remove('mm-visible');    
  })
  PANEL_FILTER.classList.remove('mm-visible');
  //mmUpdateProductInput('#product_form_option_variant_id', '', '', '');
  //mmUpdateProductInput('#product_form_option_correction_variant_id', '', '', '');
  mmRemoveFileFromInputs();
  mmClearOrdoInputs();
  mmUncheckAllButtons();
  document.querySelector('#ShopifyChat')?.classList.remove('mm-opacity-0');
  setTimeout(() => {
    document.querySelector('.mm-section-header').style.zIndex = "16";
  }, "600");

  // deactivate correction inputs
  const inputs = document.querySelectorAll('.mm-product-panel-inputs input');
  inputs.forEach(function(input) {
    input.name = '';
  })

  // empty option inputs  
  const qttyInputs = document.querySelectorAll('[data-option-quantity]');
  qttyInputs.forEach(function(qttyInput) {
    qttyInput.name = '';    
  })
}
function mmGoToPanel(index) {
  document.querySelector('.mm-product-options-panel-6').classList.remove('mm-visible');
}

function mmValidateBtn(input) {
  const container = input.closest('[data-container');
  const inputs = container.querySelectorAll('input:required');
  const button = container.querySelector('button:disabled');

  // Vérifie si tous les inputs ont une valeur non vide
  const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');

  // Active ou désactive le bouton en fonction
  button.disabled = !allFilled;
}

function mmUncheckAllButtons() {
  const buttons = document.querySelectorAll('data-container button[type="button"]');  
  buttons.forEach(function(button) {
    button.classList.remove('mm-active');
  })
}

function mmUpdateProductInput(input_id, name, variant_id, next_input_value) {
  const input = document.querySelector(input_id);
  const new_input = input.nextElementSibling;
  
  input.name = name;
  input.value = variant_id;
  new_input.value = next_input_value;
}

function mmClearOrdoInputs() {
  const inputs = document.querySelectorAll('.mm-clear input');
  const buttons = document.querySelectorAll('button.mm-clear');

  inputs.forEach(function(input) {
    input.value = "";
  })
  buttons.forEach(function(button){
    button.disabled = true;
  })
}

function mmAddColorsWithCorrection(button) {
  const activeCards = document.querySelectorAll('.mm-product-panel-color-sup-card.mm-activated');
  activeCards.forEach(function(activeCard) {
    activeCard.querySelectorAll('[data-color-correction-input]').forEach(function(input) {
      input.name = input.dataset.name;
    })
  })
}

function mmUpdateProductInputWithHandle(input_id, name, variant_id, next_input_value, next_input_handle) {
  const input = document.querySelector(input_id);
  if (input) {
    const new_input = input.nextElementSibling;
    const handle_input = new_input.nextElementSibling;
    
    input.name = name;
    input.value = variant_id;
    new_input.value = next_input_value;
  
    handle_input.value = next_input_handle;    
  }
}

// LOAD PRODUCT INFOS
function mmLoadProductSectionHTML(productHandle) {
  const sectionIdInput = document.getElementById('randomProductUrl');
  const sectionId = sectionIdInput ? sectionIdInput.value : '';
  
  const fetchUrl = sectionId ? `/products/${productHandle}?section_id=${sectionId}` : `/products/${productHandle}`;
  
  return fetch(fetchUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Erreur ${response.status}`);
      }
      return response.text();
    })
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Panel 1
      const newPanel1 = doc.querySelector('.mm-product-options-panel-1');
      newPanel1.querySelector('.mm-product-panel-footer').innerHTML = `
        <button type="button" class="mm-btn mm-big-20 mm-btn-secondary mm-w-full mm-strip-btn mm-flex mm-justify-between mm-align-center" onclick="mmVerresMode = 'seuls';mmSyncColorPricesHTML();mmOpenPanel(2);mmRemoveProductPrice();" data-cta-update-if-monture-unavailable>
          <span>Acheter des verres seuls</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          	<path d="M8.45898 6.91797L11.541 9.99951L8.45898 13.0815" stroke="black" stroke-linecap="square" stroke-linejoin="bevel"></path>
          </svg>
        </button>
        <button type="button" class="mm-btn mm-big-20 mm-btn-primary mm-w-full mm-strip-btn mm-flex mm-justify-between mm-align-center" onclick="mmVerresMode = 'monture';mmSyncColorPricesHTML();mmOpenPanel(2);mmKeepProductPrice();" data-cta-update-if-monture-unavailable>
            <span>Ajouter et personnaliser mes verres</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          	<path d="M8.45898 6.91797L11.541 9.99951L8.45898 13.0815" stroke="white" stroke-linecap="square" stroke-linejoin="bevel"></path>
          </svg>
        </button>
      `;
      document.querySelector('.mm-product-options-panel-1').innerHTML = newPanel1.innerHTML;
      mmLoadPanel1Splide();

      // Panel 2 + 6
      const buttonVerresSeuls = document.querySelector('.mm-product-options-panel-1 .mm-product-panel-footer .mm-btn-secondary');
      const buttonMonturesEtVerres = document.querySelector('.mm-product-options-panel-1 .mm-product-panel-footer .mm-btn-primary');
      const newPanel6 = doc.querySelector('.mm-product-options-panel-6');
      newPanel6.querySelector('.mm-product-options-panel-recap-price-container').classList.add("mm-none");
      document.querySelector('.mm-product-rainbow-panel-2').innerHTML = newPanel6.innerHTML;
      const clickEvent = new Event('click');
      document.querySelector('.mm-product-rainbow-panel-2 .mm-product-panel-colors-tabs-titles button:first-child').dispatchEvent(clickEvent);   
      document.querySelectorAll('.mm-product-options-panel-recap-price-container').forEach(function(elem) {
        elem.classList.add('mm-none');
      })

      buttonVerresSeuls.addEventListener('click', function() {
        document.querySelector('.mm-product-options-panel-6-cta-add-w').onclick = function () {
          mmAddColorsWithCorrection(this);
          mmOpenPanel(4);
          mmUpdateProductInputWithHandle('#product_form_option_correction_variant_id', 'items[1]id', '50758562349322', 'Traitement verre teinté au modèle', 'teinte-au-modele');
        };
        // Change product_id
        const input = document.getElementById('product_form_selected_variant_id');
        input.name = '';
        input.value = '';
        // Remove product price in CTA
        document.querySelectorAll('.mm-product-rainbow-panel-2 .mm-product-panel-footer button').forEach(function(button) {
          button.dataset.totalPrice = 0;
          button.querySelector('[data-cta-price]').innerText = `0 EUR`
        })
      })
      
      buttonMonturesEtVerres.addEventListener('click', function() {
        document.querySelector('.mm-product-options-panel-6-cta-add-w').onclick = function () {
          mmAddColorsWithCorrection(this);
          mmOpenPanel(4);
          mmUpdateProductInputWithHandle('#product_form_option_correction_variant_id', 'items[1]id', '50758562349322', 'Traitement verre teinté au modèle', 'teinte-au-modele');
        };
        // Change product_id
        const input = document.getElementById('product_form_selected_variant_id');
        input.name = 'items[0]id';
        input.value = document.querySelector('.mm-product-options-panel-1-montures-slider-2 input:checked').dataset.variantId;
        // Add product price in CTA
        document.querySelectorAll('.mm-product-rainbow-panel-2 .mm-product-panel-footer button').forEach(function(button) {
          const productPrice = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-price-container').dataset.price;
          button.dataset.totalPrice = productPrice;
          button.querySelector('[data-cta-price]').innerText = `${productPrice / 100} EUR`
        })
      })

      // Update recap
      document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-subtitle').innerText = '';
      const imageSrc = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-image').src;
      const productTitle = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-title').innerText;
      const productColor = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-subtitle').innerText;
      document.querySelectorAll('.mm-product-panel-recap-image-empty').forEach(function(imageElem) {
        imageElem.src = imageSrc;
      })
      document.querySelector('.mm-product-options-panel-4 .mm-product-options-panel-recap-title').innerText = productTitle;
      document.querySelector('.mm-product-options-panel-4 .mm-product-options-panel-recap-subtitle').innerText = productColor;

      // Clean colors when we get out
      document.querySelectorAll('.mm-product-rainbow-panel-2 .mm-product-options-panel-header button').forEach(function(button) {
        button.addEventListener('click', function() {
          mmCleanVerresRainbow(button);
        })
      })

      document.dispatchEvent(new CustomEvent('reloadLazyLoad'));
    })
    .catch(error => {
      console.error('Erreur lors du chargement de la section produit:', error);
    });

  
}



// TABS VERRES COLORS -- RAINBOW =====================================================================

let mmVerresMode = 'monture'; // 'monture' ou 'seuls'

function mmVerresColorsTabs(button) {  
  const container = button.closest('[data-container]');
  const selected_category = button.dataset.category;

  // Buttons
  container.querySelectorAll('.mm-product-panel-colors-tabs-titles button').forEach(function(elem){
    elem.classList.remove('mm-activated');
  })
  button.classList.add('mm-activated');

  // Colors
  const color_elements = container.querySelectorAll('[data-color]');
  color_elements.forEach(function(color_element) {
    if (color_element.dataset.categories.includes(selected_category)) {
      color_element.classList.remove('mm-none');      
    } else {
      color_element.classList.add('mm-none');      
    }
  })
  
  //resetvariant();
}

// ADD NEW COLOR
function mmProductPanelAddColor(button) {
  const container = button.closest('.mm-panel');
  const card = button.closest('.mm-product-panel-color-sup-card');
  const cards = container.querySelectorAll('.mm-product-panel-color-sup-card');
  const quantitySelector = card.querySelector('[data-quantity-selector]');
  const delButton = card.querySelector('.mm-product-panel-color-sup-card-del-btn');

  const listings = document.querySelectorAll('.mm-product-options-panel-recap-subtitle');
  const color_name = card.dataset.colorName;

  const activeBefore = container.querySelectorAll('.mm-product-panel-color-sup-card.mm-activated').length;

  const baseColorPriceCts  = parseInt(card.dataset.colorPriceCts || '0', 10);
  const afterColorPriceCts = parseInt(card.dataset.colorPriceCtsAfter || card.dataset.colorPriceCts || '0', 10);

  let appliedColorPriceCts;

  if (mmVerresMode === 'monture') {
      appliedColorPriceCts = (activeBefore === 0)
          ? baseColorPriceCts    
          : afterColorPriceCts;   
  }

  else if (mmVerresMode === 'seuls') {
      appliedColorPriceCts = afterColorPriceCts; 
  }

  card.dataset.appliedColorPriceCts = appliedColorPriceCts.toString();

  const color_price = appliedColorPriceCts;

  const recapContainer = document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container');
  const currentPrice = parseInt(recapContainer.dataset.price || '0', 10);
  const currentCompareAtPrice = parseInt(recapContainer.dataset.compareAtPrice || '0', 10);

  const newPrice = `${( currentPrice + color_price ) / 100} EUR`;
  const newCompareAtPrice = `${( currentCompareAtPrice + color_price ) / 100} EUR`;

  const recapPrices = document.querySelectorAll('.mm-product-options-panel-recap-price');
  const recapCompareAtPrices = document.querySelectorAll('.mm-product-options-panel-recap-compare-at-price');

  const CTAs = document.querySelectorAll('.mm-product-rainbow-panel-2 .mm-product-panel-footer button');
  const CTAWithPrice = document.querySelector('.mm-product-options-panel-6-cta-add-w [data-cta-price]');
  const CTAWithoutPrice = document.querySelector('.mm-product-options-panel-6-cta-add-wo [data-cta-price]');
  const totalPriceWithCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice || '0', 10);
  const totalPriceWithoutCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice || '0', 10);

  const inputVariantId = card.querySelector('.mm-product-panel-color-sup-variant-id-input');
  const inputVariantQuantity = card.querySelector('.mm-product-panel-color-sup-variant-qtty-input');
  const inputProductNameProperty = card.querySelector('.mm-product-panel-color-sup-product-title-input');
  const inputRainbowProperty = card.querySelector('.mm-product-panel-color-sup-rainbow-input');

  const ordnanceInputs = document.querySelectorAll('[data-ordonance-input]');

  // Change card
  card.classList.add('mm-activated');
  quantitySelector.value = 2;
  button.classList.add('mm-none');
  delButton.classList.remove('mm-none');

  // Add text info
  listings.forEach(function(listing) {
    let colors = getColorsFromListing(listing);
    if (!colors.includes(color_name)) {
      colors.push(color_name);
    }
    setColorsToListing(listing, colors);
  });

  // Update previousQuantity
  card.dataset.previousQuantity = quantitySelector.value;

  // Change price on recap
  recapPrices.forEach(function(recapPrice) {
    recapPrice.innerHTML = newPrice;
  });
  recapContainer.dataset.price = currentPrice + color_price;

  recapCompareAtPrices.forEach(function(recapCompareAtPrice) {
    recapCompareAtPrice.innerHTML = newCompareAtPrice;
  });
  recapContainer.dataset.compareAtPrice = currentCompareAtPrice + color_price;

  // Change price on CTA
  const correctionPrice = parseInt(card.dataset.correctionPriceCts || '0', 10);

  const newTotalWithCorrection = totalPriceWithCorrection + color_price + correctionPrice;
  const newTotalWithoutCorrection = totalPriceWithoutCorrection + color_price;

  document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice = newTotalWithCorrection;
  CTAWithPrice.innerHTML = `${( newTotalWithCorrection ) / 100} EUR`;

  document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice = newTotalWithoutCorrection;
  CTAWithoutPrice.innerHTML = `${( newTotalWithoutCorrection ) / 100} EUR`;

  // Inputs
  inputVariantId.name = inputVariantId.dataset.name;
  inputVariantQuantity.name = inputVariantQuantity.dataset.name;
  inputProductNameProperty.name = inputProductNameProperty.dataset.name;
  if (inputRainbowProperty) {
    if (appliedColorPriceCts === 0 && mmVerresMode === 'monture') {
      inputRainbowProperty.name = inputRainbowProperty.dataset.name;
    } else {
      inputRainbowProperty.name = "";
    }
  }

  // Update CTAs availability
  CTAs.forEach(function(CTA) {
    CTA.disabled = false;
  });

  // Update total quantity
  mmUpdateTotalVerresQuantity();

  // Add index to ordo inputs
  ordnanceInputs.forEach(function(input) {
    input.dataset.name = input.dataset.name.replace(input.dataset.currentIndex, card.dataset.ordoIndex);
    input.dataset.currentIndex = card.dataset.ordoIndex;
  });

  // Change colors price (visuel)
  const allPrices = document.querySelectorAll('[data-color-price]');
  if (mmVerresMode === 'monture') {
    // Monture : premier verre gratuit, les suivants payants
    allPrices.forEach(function(priceElem) {
      priceElem.innerText = priceElem.dataset.colorPrice;
    });
    cards.forEach(function(card) {
      card.dataset.colorPriceCts = card.dataset.colorPriceCtsAfter;
    });
  } else {
    // Verres seuls : tous les verres payants → afficher directement le prix (jamais "inclus")
    allPrices.forEach(function(priceElem) {
      priceElem.innerText = priceElem.dataset.colorPrice;
    });
    cards.forEach(function(card) {
      card.dataset.colorPriceCts = card.dataset.colorPriceCtsAfter;
    });
  }
}


function mmProductPanelDelColor(button) {
  const container = button.closest('.mm-panel');
  const card = button.closest('.mm-product-panel-color-sup-card');
  const cards = container.querySelectorAll('.mm-product-panel-color-sup-card');
  const quantitySelector = card.querySelector('[data-quantity-selector]');
  const addButton = card.querySelector('.mm-product-panel-color-sup-card-add-btn');

  const listings = document.querySelectorAll('.mm-product-options-panel-recap-subtitle');
  const color_name = card.dataset.colorName;

  // 🆕 Prix réellement appliqué à cette carte
  const previousPrice = parseInt(card.dataset.appliedColorPriceCts || card.dataset.colorPriceCts || '0', 10);

  const recapContainer = document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container');
  const currentPrice = parseInt(recapContainer.dataset.price || '0', 10);
  const currentCompareAtPrice = parseInt(recapContainer.dataset.compareAtPrice || '0', 10);

  const newPrice = `${( currentPrice - previousPrice ) / 100} EUR`;
  const newCompareAtPrice = `${( currentCompareAtPrice - previousPrice ) / 100} EUR`;

  const recapPrices = document.querySelectorAll('.mm-product-options-panel-recap-price');
  const recapCompareAtPrices = document.querySelectorAll('.mm-product-options-panel-recap-compare-at-price');

  const CTAs = document.querySelectorAll('.mm-product-rainbow-panel-2 .mm-product-panel-footer button');
  const CTAWithPrice = document.querySelector('.mm-product-options-panel-6-cta-add-w [data-cta-price]');
  const CTAWithoutPrice = document.querySelector('.mm-product-options-panel-6-cta-add-wo [data-cta-price]');
  const totalPriceWithCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice || '0', 10);
  const totalPriceWithoutCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice || '0', 10);

  const inputVariantId = card.querySelector('.mm-product-panel-color-sup-variant-id-input');
  const inputVariantQuantity = card.querySelector('.mm-product-panel-color-sup-variant-qtty-input');
  const inputProductNameProperty = card.querySelector('.mm-product-panel-color-sup-product-title-input');
  const inputRainbowProperty = card.querySelector('.mm-product-panel-color-sup-rainbow-input');

  const ordnanceInputs = document.querySelectorAll('[data-ordonance-input]');

  const productPriceCts = parseInt(document.querySelector('.mm-product-rainbow-panel-2').dataset.productPrice || '0', 10);

  // === Mise à jour de la carte ===
  card.classList.remove('mm-activated');
  quantitySelector.value = 0;
  button.classList.add('mm-none');
  addButton.classList.remove('mm-none');

  // Texte recap
  listings.forEach(function(listing) {
    let colors = getColorsFromListing(listing);
    colors = colors.filter(color => color !== color_name);
    setColorsToListing(listing, colors);
  });

  card.dataset.previousQuantity = quantitySelector.value;

  // Recap prix
  recapPrices.forEach(function(recapPrice) {
    recapPrice.innerHTML = newPrice;
  });
  recapContainer.dataset.price = currentPrice - previousPrice;

  recapCompareAtPrices.forEach(function(recapCompareAtPrice) {
    recapCompareAtPrice.innerHTML = newCompareAtPrice;
  });
  recapContainer.dataset.compareAtPrice = currentCompareAtPrice - previousPrice;

  // CTA prix
  const correctionPrice = parseInt(card.dataset.correctionPriceCts || '0', 10);

  const newTotalWithCorrection = totalPriceWithCorrection - previousPrice - correctionPrice;
  const newTotalWithoutCorrection = totalPriceWithoutCorrection - previousPrice;

  const ctaWithBtn = document.querySelector('.mm-product-options-panel-6-cta-add-w');
  const ctaWithoutBtn = document.querySelector('.mm-product-options-panel-6-cta-add-wo');

  // 🆕 Recompter les cartes actives après la suppression
  const activeCards = container.querySelectorAll('.mm-product-panel-color-sup-card.mm-activated');
  const activeCount = activeCards.length;

  if (activeCount === 0) {
    // Plus aucun verre sélectionné → on revient au prix de base du produit (en centimes)
    ctaWithBtn.dataset.totalPrice = productPriceCts;
    ctaWithoutBtn.dataset.totalPrice = productPriceCts;

    const display = productPriceCts === 0
      ? '0 EUR'
      : `${(productPriceCts / 100)} EUR`;

    CTAWithPrice.innerHTML = display;
    CTAWithoutPrice.innerHTML = display;

    // Désactiver les CTA
    CTAs.forEach(function(CTA) {
      CTA.disabled = true;
    });
  } else {
    // Il reste au moins un verre → on affiche les totaux recalculés
    ctaWithBtn.dataset.totalPrice = newTotalWithCorrection;
    ctaWithoutBtn.dataset.totalPrice = newTotalWithoutCorrection;

    CTAWithPrice.innerHTML = `${( newTotalWithCorrection ) / 100} EUR`;
    CTAWithoutPrice.innerHTML = `${( newTotalWithoutCorrection ) / 100} EUR`;
  }

  // Inputs
  inputVariantId.name = "";
  inputVariantQuantity.name = "";
  inputProductNameProperty.name = "";
  if (inputRainbowProperty) inputRainbowProperty.name = "";
  if (inputRainbowProperty) inputRainbowProperty.name = "";

  // Update total quantity
  mmUpdateTotalVerresQuantity();

  // Ordo index
  const activatedCard = container.querySelector('.mm-product-panel-color-sup-card.mm-activated');
  if (activatedCard) {
    ordnanceInputs.forEach(function(input) {
      input.dataset.name = input.dataset.name.replace(input.dataset.currentIndex, activatedCard.dataset.ordoIndex);
      input.dataset.currentIndex = activatedCard.dataset.ordoIndex;
    });
  } else {
    ordnanceInputs.forEach(function(input) {
      input.dataset.name = input.dataset.name.replace(input.dataset.currentIndex, '0');
      input.dataset.currentIndex = '0';
    });
  }

  // Changement de prix visuel “inclus / 19 EUR”
  const allPrices = document.querySelectorAll('[data-color-price]');
  if (activeCount === 0) {

    // Cas MONTURE → le premier verre redevient gratuit
    if (mmVerresMode === 'monture') {
      allPrices.forEach(function(priceElem) {
        priceElem.innerText = priceElem.dataset.freeText;
      });
      cards.forEach(function(card) {
        card.dataset.colorPriceCts = 0;
      });
    }

    // Cas VERRES SEULS → aucun verre gratuit, même après reset
    else {
      allPrices.forEach(function(priceElem) {
        priceElem.innerText = priceElem.dataset.colorPrice; // prix normal
      });
      cards.forEach(function(card) {
        card.dataset.colorPriceCts = card.dataset.colorPriceCtsAfter;
      });
    }
  }

}


function mmKeepProductPrice() {
  const productPrice = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-price-container').dataset.price;
  document.querySelector('.mm-product-rainbow-panel-2').dataset.productPrice = productPrice;
}

function mmRemoveProductPrice() {
  const productPrice = document.querySelector('.mm-product-rainbow-panel-2 .mm-product-options-panel-recap-price-container').dataset.price;
  document.querySelector('.mm-product-rainbow-panel-2').dataset.productPrice = 0;
}

function mmSyncColorPricesHTML() {
  const cards = document.querySelectorAll('.mm-product-panel-color-sup-card');
  const allPrices = document.querySelectorAll('[data-color-price]');
  const freeTexts = document.querySelectorAll('[data-free-text]');

  if (mmVerresMode === 'seuls') {
    allPrices.forEach(priceElem => {
      priceElem.innerText = priceElem.dataset.colorPrice;
    });

    cards.forEach(card => {
      card.dataset.colorPriceCts = card.dataset.colorPriceCtsAfter;
    });
  } 
  else {
    allPrices.forEach(priceElem => {
      priceElem.innerText = priceElem.dataset.freeText;
    });

    const firstFreeElem = document.querySelector('[data-color-free]');
    if (firstFreeElem) {
      firstFreeElem.innerText = firstFreeElem.dataset.freeText;
    }

    cards.forEach(card => {
      card.dataset.colorPriceCts = card.dataset.colorPriceCts;
    });
  }
}


function getColorsFromListing(listing) {
  const span = listing.querySelector('[data-color]');
  if (!span) return [];

  const text = span.textContent.replace(/\s*\(.*?\)\s*/, '').trim(); // Nettoyage éventuel
  const colorTexts = text.split(',').map(c => c.trim()).filter(c => c !== '');
  
  return colorTexts;
}

function setColorsToListing(listing, colors) {
  // Supprimer l’ancien bloc si présent
  const oldSpan = listing.querySelector('[data-color]');
  if (oldSpan) oldSpan.remove();

  // Reconstruire le texte
  const text = colors.join(', ');

  // Réinsérer le nouveau bloc
  listing.insertAdjacentHTML('beforeend', 
    `<span class="text-xs-caps mm-black-500" data-color="">${text} <span class="text-xs-caps mm-black-500" data-color-qtty></span></span>`
  );
}

// GET FULL NB OF COLORS SELECTED AND UPDATE QUANTITY INPUT
function mmUpdateTotalVerresQuantity() {
  let total = 0;

  document.querySelectorAll('.mm-product-panel-color-sup-variant-qtty-input').forEach(input => {
    const value = parseFloat(input.value);
    if (!isNaN(value)) {
      total += value;
    }
  });

  const targetInput = document.querySelector('#product_form_option_correction_quantity');
  if (targetInput) {
    targetInput.value = total;
  }
}

// CLEAN COLOR
function mmCleanVerresRainbow(button) {
  const container = button.closest('.mm-product-rainbow-panel-2');
  const delButtons = container.querySelectorAll('.mm-product-panel-color-sup-card-del-btn:not(.mm-none)');

  delButtons.forEach(function(delButton) {
    const clickEvent = new Event('click');
    delButton.dispatchEvent(clickEvent);
  })
}

// SHOW CORRECTION PRICE
function mmShowCorrectionPrice(card) {
  const price = card.dataset.correctionPrice;
  const container = card.closest('[data-container]');
  const priceContainerElem = container.querySelector('[data-correction-price-text]');
  const priceElem = priceContainerElem.querySelector('span');
  
  const imageUrl = card.dataset.image;
  const imageHtmlContainer = document.querySelector('.mm-product-panel-6-image-preview-wrapper');
  const imageHtmlElement = imageHtmlContainer.querySelector('img');

  priceContainerElem.classList.remove('mm-none');
  priceElem.innerText = price;

  imageHtmlContainer.classList.remove('mm-none');
  imageHtmlElement.src = imageUrl;    
}

function mmHideCorrectionPrice(card) {
  const container = card.closest('[data-container]');
  const priceContainerElem = container.querySelector('[data-correction-price-text]');
  
  const imageHtmlContainer = document.querySelector('.mm-product-panel-6-image-preview-wrapper');

  priceContainerElem.classList.add('mm-none');

  imageHtmlContainer.classList.add('mm-none');
}


// FILE UPLOAD
function mmInitAllDropZones() {
  document.querySelectorAll('.file-drop-wrapper').forEach(wrapper => {
    const dropZone = wrapper.querySelector('.file-drop-zone');
    const fileInput = wrapper.querySelector('.file-input');
    const icon = dropZone.querySelector('.mm-product-file-upload-icon');
    const textSpan = wrapper.querySelector('.file-name');
    const textSpan2 = wrapper.querySelector('.file-size');
    const validateBtn = wrapper.querySelector('.validate-btn');
    const fileAddedElement = wrapper.querySelector('.file-added');
    
    const downloadLink = document.querySelector('.mm-product-panel-recap-listing-ordonnance-file a');
    const recapFile = document.querySelector('.mm-product-panel-recap-listing-ordonnance-file');
    const recapInputs = document.querySelectorAll('.mm-product-panel-recap-listing-ordonnance-inputs');

    let fileURL = null;

    const updateButtonState = () => {
      const hasFile = fileInput.files.length > 0;
      validateBtn.disabled = !hasFile;
      if (downloadLink) {
        downloadLink.style.display = hasFile ? 'inline-block' : 'none';        
      }

      if (hasFile) {
        fileInput.name = fileInput.dataset.name;
        const file = fileInput.files[0];
        if (fileURL) URL.revokeObjectURL(fileURL);
        fileURL = URL.createObjectURL(file);
        if (downloadLink) {
          downloadLink.href = fileURL;
          downloadLink.download = file.name;
          downloadLink.style.pointerEvents = "auto";
          downloadLink.style.textDecoration = "underline";
          downloadLink.innerText = "Consulter";
        }
        if(recapFile) {
          recapFile.style.display = 'flex';          
        }
        recapInputs.forEach(i => i.style.display = 'none');
      } else {
        fileInput.name = '';
        if (downloadLink) {
          downloadLink.href = '#';
        }
        if(recapFile) {
          recapFile.style.display = 'none';          
        }
        recapInputs.forEach(i => i.style.display = 'flex');
      }
    };

    dropZone.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', () => {
      if (fileInput.files.length > 0) {
        fileInput.name = fileInput.dataset.name;
        const file = fileInput.files[0];
        textSpan.textContent = file.name;
        const sizeInMb = ((file.size * 8) / 1_000_000).toFixed(2);
        textSpan2.textContent = `${sizeInMb} Mb`;
        dropZone.classList.add('mm-none');
        fileAddedElement.classList.remove('mm-none');
      } else {
        fileInput.name = '';
        dropZone.classList.remove('mm-none');
        fileAddedElement.classList.add('mm-none');
        textSpan.textContent = '';
        textSpan2.textContent = '';
      }
      updateButtonState();
    });

    dropZone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropZone.classList.add('dragover');
    });

    dropZone.addEventListener('dragleave', () => {
      dropZone.classList.remove('dragover');
    });

    dropZone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropZone.classList.remove('dragover');
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        fileInput.name = fileInput.dataset.name;
        fileInput.files = files;
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event); // simule changement
      }
    });

    // bouton supprimer le fichier
    const removeBtn = wrapper.querySelector('.remove-file');
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        fileInput.name = '';
        fileInput.value = '';
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event);
      });
    }

    updateButtonState(); // init
  });
}

function mmRemoveFileFromInputs() {
  const inputs = document.querySelectorAll('.remove-file');
  inputs.forEach(function(input) {
    const clickEvent = new Event('click');
    input.dispatchEvent(clickEvent)
  })
}

function mmAddOrRemoveName(input) {
  if (input.value.trim() !== '') {
    input.name = input.dataset.name;
  } else {
    input.name = '';
  }
}


function mmShowVerresImage(card) {  
  const imageUrl = card.dataset.image;
  const imageHtmlContainers = document.querySelectorAll('.mm-product-panel-6-image-preview-wrapper');
  const panel2 = document.querySelector('.mm-product-options-panel-2');
  
  if (panel2.classList.contains('mm-visible')) {

    imageHtmlContainers.forEach(function(imageHtmlContainer) {
      const imageHtmlElement = imageHtmlContainer.querySelector('img');
    
      imageHtmlContainer.classList.remove('mm-none');
      imageHtmlElement.classList.remove('mm-none');
      imageHtmlElement.src = imageUrl;  
    })
  }
}

function mmHideVerresImage() {  
  const imageHtmlContainers = document.querySelectorAll('.mm-product-panel-6-image-preview-wrapper');

  imageHtmlContainers.forEach(function(imageHtmlContainer) {
    imageHtmlContainer.classList.add('mm-none');  
  })
}

// Get product section id on load
function getSectionProductIdOnLoad() {
  const url = document.querySelectorAll('.mm-product-card-container')[0].dataset.href;
  const input = document.getElementById('randomProductUrl');

  fetch(url)
  .then(function(response) {
    if (!response.ok) {
      throw new Error("Erreur HTTP: " + response.status);
    }
    return response.text();
  })
  .then(function(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    
    // Ensuite on sélectionne l'élément souhaité
    const element = doc.querySelector(".mm-main-product-grid");
    
    if (!element) {
      return
    }

    const id = element.id;
    input.value = id;
  })
  .catch(function(error) {
    console.error("Erreur lors du fetch :", error);
  });
}

document.addEventListener("DOMContentLoaded", (event) => {
  mmInitAllDropZones();
  getSectionProductIdOnLoad();
});










